import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import { toggleModal } from '~/components/modal';

export class GalleryMap extends AbstractComponent {
  init() {
    const items = this.el.querySelectorAll('[data-number]');

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        const sameNumberItems = [...items].filter((i) => i.dataset.number === item.dataset.number);
        sameNumberItems.forEach((i) => i.classList.add('is-hovered'));
      });

      item.addEventListener('mouseleave', () => {
        items.forEach((i) => i.classList.remove('is-hovered'));
      });

      item.addEventListener('click', () => {
        toggleModal(`entry-${item.dataset.id}`)
      });
    })
  }
}

register('gallery-map', GalleryMap);
